<template>
	<div>
		<el-card class="box-card">
			<el-form label-width="80px" :inline="true">
				<el-form-item label="订单ID:">
					<el-input v-model="listQuery.search.order_id" placeholder=""></el-input>
				</el-form-item>
			</el-form>
			<el-button type="primary" icon="el-icon-search" @click="keySearch">搜索</el-button>
		</el-card>

		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<!-- <el-table-column prop="id" label="ID"></el-table-column> -->
				<el-table-column prop="order_id" label="订单ID"></el-table-column>
				<el-table-column prop="xd_order_money" label="下单金额">
					<template slot-scope="{row}">
						<span>{{ row.xd_order_money}} {{row.xd_order_money_coin}}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="fs_money" label="运费"></el-table-column> -->
				<!-- <el-table-column prop="lucky_money" label="追加红包"></el-table-column> -->
				<el-table-column prop="c_money" label="佣金"></el-table-column>
				<!-- <el-table-column prop="total_money" label="总金额"></el-table-column> -->
				<el-table-column prop="create_time" label="到账时间">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
		</div>
	</div>
</template>

<script>
	import {
		commissionList,
	} from '@/api/jd_task'
	import request from '@/tool/request'
	import {
		parseTime
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import Dtp from '@/components/Ele/dateTimePicker.vue' // 时间选择组件
	export default {
		components: {
			Pagination,
			Dtp
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				is_show_search: false, // 搜索模态框
				data_list: [], // 表格数据
				loading: true,
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},

			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						
					},
				}
			},
			resetSearch() { // 重置搜索
				this.resetSearchData()
				this.getList()
			},
			getList() { // 获取列表数据
				this.loading = true;
				commissionList(Qs.stringify(this.listQuery)).then(response => {
					this.data_list = response.result.items;
					this.total = response.result.total;
					
					this.loading = false;
				})
			},
		}
	}
</script>
